module.exports = __webpack_public_path__ + "static/media/calendarGraphicNew.86988503.png";